var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-upload',{attrs:{"name":"file","accept":_vm.accept,"file-list":_vm.internalFileList,"remove":_vm.handleRemove,"before-upload":_vm.handleBeforeUpload,"custom-request":_vm.handleCustomUpload,"disabled":_vm.disabled}},[_c('a-button',{staticClass:"my-5 upload_new",attrs:{"disabled":_vm.uploading}},[_vm._v(" "+_vm._s(_vm.uploadText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }